import * as types from '../../constants/actionTypes';
import {firebase} from '../../firebase'

function receiveAuthenticatedUser(user) {
  return {
    type: types.RECEIVE_AUTHENTICATED_USER,
    user: user
  }
}

function receiveSignOut() {
  return {
    type: types.RECEIVE_SIGN_OUT_USER
  }
}

export function signInWithGoogle() {
  const provider = new firebase.auth.GoogleAuthProvider();
  return dispatch => {
    return firebase.auth().signInWithPopup(provider).then((result) => {
      firebase.database().ref().child(`users/${result.user.uid}`).set({
        uid: result.user.uid,
        name: result.user.displayName,
        email: result.user.email,
        avatarUrl: result.user.photoURL
      });
      dispatch(receiveAuthenticatedUser(result.user));
    });
  }
}

export function syncSession() {
  return dispatch => {
    return firebase.auth().onAuthStateChanged(function(user) {
      if (user) {
        dispatch(receiveAuthenticatedUser(user));
      }
    });
  }
}

export function signOut() {
  return dispatch => {
    return firebase.auth().signOut().then(function() {
      dispatch(receiveSignOut());
    });
  }
}



/** WEBPACK FOOTER **
 ** ./src/actions/auth/index.js
 **/